module.exports = __webpack_public_path__ + "img/top_and_waistband_back_buttons_quantity.637cf830.png";